'use strict';

const Route = require('common/route');
const Ajax = require('common/infra/ajax');
const ViewerCollection = require('balus/domain/collection/viewer');

class ViewerRepository {
    constructor() {
        this._viewers = {};
    }

    /**
     * @param {Object} context
     * @returns {string}
     * @private
     */
    _cacheKey(context) {
        return `${context.projectId}:${context.diagramId}:${context.actionId}`
    }

    _viewer(context) {
        const key = this._cacheKey(context);
        return this._viewers[key];
    }

    _new(context) {
        const key = this._cacheKey(context);
        const viewer = new ViewerCollection();
        this._viewers[key] = viewer;
        return viewer;
    }

    _fetchDiagramViewer(context) {
        // const url = Route.urlFor('api:viewers:diagram', context);
        // return Ajax.GET(url)
        //     .then(viewersJSON => {
        //         const viewer = this._viewer(context);
        //         viewer.add(viewersJSON);
        //     });
    }

    _fetchActionViewer(context) {
        // const url = Route.urlFor('api:viewers:action', context);
        // return Ajax.GET(url)
        //     .then(viewersJSON => {
        //         const viewer = this._viewer(context);
        //         viewer.add(viewersJSON);
        //     });
    }

    getViewer(context) {
        let viewer = this._viewer(context);
        if(!viewer) {
            viewer = this._new(context);
            if(context.diagramId) {
                this._fetchDiagramViewer(context);
            }
            if(context.actionId) {
                this._fetchActionViewer(context);
            }
        }
        return viewer;
    }

}

module.exports = new ViewerRepository();



// WEBPACK FOOTER //
// ./balus/domain/repository/viewer.js